export default {
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.guide": "Spreadsheet Guide",
  "nav.categories": "Categories",
  "nav.visitSite": "Visit Main Website",

  "hero.badge": "Updated resources · Organized by category",
  "hero.title": "AllChinaBuy Spreadsheet",
  "hero.subtitle": "Find products, sellers and buying resources across the latest AllChinaBuy spreadsheet — organized in one simple place.",
  "hero.ctaPrimary": "allchinabuy spreadsheet",
  "hero.ctaSecondary": "buy it now",

  "dropdown.label": "Choose a category",
  "dropdown.placeholder": "Select a category…",

  "categories.title": "Explore Product Categories",
  "categories.subtitle": "Jump straight to the category you are looking for on the main website.",

  "text.title": "What is the AllChinaBuy Spreadsheet?",
  "text.paragraph1": "The AllChinaBuy spreadsheet is a shared resource that brings together product links, seller information and category listings in one organized view. Instead of searching through countless pages, you can use it as a starting point to discover items across fashion, sneakers, streetwear, bags and more.",
  "text.paragraph2": "This site is an independent information hub. We organize the categories so you can move quickly from a topic you are interested in to the main website, where the full product listings live.",

  "articleLink.title": "Read the Full Guide",
  "articleLink.subtitle": "Learn how to use the AllChinaBuy spreadsheet, what each category includes and how to shop safely.",
  "articleLink.cta": "Read the guide",

  "footer.disclaimer": "This is an independent informational resource. Product links open on the main website kaspreadsheet.com.",
  "footer.rights": "AllChinaBuy Spreadsheet Hub.",

  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies/Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants/Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "underwear/underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",

  "products.featuredTitle": "Featured Products",
  "products.featuredSubtitle": "Explore popular products from the AllChinaBuy spreadsheet. Click to view and purchase on the main website.",
  "products.viewAll": "View All Products",

  "article.title": "AllChinaBuy Spreadsheet Guide: Products, Categories & How to Use It",
  "article.back": "Back to home",
  "article.published": "Updated",
  "article.intro": "The AllChinaBuy spreadsheet is one of the quickest ways to browse a wide range of products from a single organized resource. In this guide we explain what the spreadsheet is, how the categories are laid out, and how to move from a category to the actual product listings.",
  "article.h2.what": "What is the AllChinaBuy Spreadsheet?",
  "article.p.what": "The AllChinaBuy spreadsheet acts as a central reference for products and sellers. It groups items into clear categories — shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes and more — so you can quickly find the section you need without browsing unrelated pages.",
  "article.h2.categories": "How the Categories Are Organized",
  "article.p.categories": "Each category on this site links directly to the matching section on the main website. When you pick a category, you are taken straight to the listings for that group. This keeps the experience simple: choose a category, open the link, and browse the products.",
  "article.h2.howto": "How to Use the Spreadsheet",
  "article.p.howto": "Start from the homepage, choose a category from the dropdown or the category buttons, and you will be taken to the main website. From there you can look through the product list, compare sellers and check details before making a decision.",
  "article.h2.safety": "Shopping Safely",
  "article.p.safety": "Always double-check product descriptions, seller ratings and shipping details on the main website before ordering. Keep your payment and account information secure, and verify links before clicking.",
  "article.conclusion": "Ready to explore? Return to the homepage to browse the categories and open the full AllChinaBuy spreadsheet listings.",
  "article.cta": "Back to AllChinaBuy Spreadsheet",
};